import React, { useState } from 'react';
import { TextField, Button, Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import axios from 'axios';
import { Theme } from '../../components/Theme';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';

export default function ForgotPassword() {
    const [input, setInput] = useState({
        email: '',
    });
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [searchParams] = useSearchParams();
    const fromUrl = searchParams.get('from') || '/';

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/account/forgot-password', {
                email: input.email,
            });
            if (response.status === 200) {
                setIsSuccess(true);
                setMessage('Please check your email to reset your password.');
            }
        } catch (error) {
            setIsSuccess(false);
            setMessage('Failed to process your request. Please try again.');
            console.error('Forgot password error:', error);
        }
    };

    return (
        <Theme>
            <Box 
                sx={{ 
                    p: 2,
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Box sx={{ maxWidth: 400, width: '100%' }}>
                    <Typography variant="h4" gutterBottom>
                        Recuperar contraseña
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12 }}>
                            {message && (
                                <Typography 
                                    color={isSuccess ? "success" : "error"} 
                                    gutterBottom
                                >
                                    {message}
                                </Typography>
                            )}
                            <form onSubmit={handleSubmit} name="forgot-password">
                                <Typography variant="body1" gutterBottom>
                                    Ingrese su correo electrónico para restablecer su contraseña.
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            variant="standard"
                                            fullWidth
                                            label="Correo electrónico"
                                            placeholder="name@example.com"
                                            name="email"
                                            value={input.email}
                                            onChange={handleChange}
                                            autoComplete="email"
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                        >
                                            Enviar enlace de recuperación
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                <Grid xs={12}>
                                    <RouterLink 
                                        to={fromUrl}
                                        style={{ color: 'primary' }}
                                    >
                                        Volver al inicio de sesión
                                    </RouterLink>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Theme>
    );
}
